import { QuestionResult } from "@apps/its2/models/question-result";

export class RequestApi
{
    requestId: number;
    rfcNumber: string;
    type: string;
    submitDateUtc: string;
    endDateUtc?: string;
    maxResolutionDateUtc: string;
    title: string;
    comment: string;
    shortComment: string;
    urgencyId: number;
    statusId: number;
    public metaStatusGuid: string;
    catalogId: string;
    recipientName: string;
    recipientEmail: string;
    recipientIsMe: boolean;
    requestorName: string;
    requestorEmail: string;
    statusFR: string;
    statusEN: string;
    catalogPathFR: string;
    catalogPathEN: string;
    urgencyFR: string;
    urgencyEN: string;
    statusMyAntemetAGuid: string;
    resolution: any;
    satisfaction?: number;
    public useCaseTypeId?: number;
    public useCaseTypeFR?: string;
    public useCaseTypeEN?: string;
    public useCaseCode?: string;
    public useCaseFR?: string;
    public useCaseEN?: string;
    public availableField3: string;
    public percentSla: number;
    questionResults!: QuestionResult[];
}

export type SimplifiedRequestApi = Pick<RequestApi,
    'rfcNumber'
    | 'type'
    | 'submitDateUtc'
    | 'title'
    | 'catalogPathFR'
    | 'catalogPathEN'
    | 'urgencyId'
    | 'statusId'
    | 'metaStatusGuid'
    | 'statusFR'
    | 'statusEN'
    | 'statusMyAntemetAGuid'
    | 'urgencyFR'
    | 'urgencyEN'
    | 'useCaseTypeId'
    | 'useCaseTypeFR'
    | 'useCaseTypeEN'
    | 'useCaseCode'
    | 'useCaseFR'
    | 'useCaseEN'
    | 'availableField3'
>;
